module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "ack"
    }
  }), _c('em', [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Being a writer as well as knowing Yiddish made Ellen Cassedy particularly helpful in her detailed editing of the entire translation. She sought to "), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _vm._v("remove deficiencies in the use of the English language and generally raise the quality of the final product while adhering to the letter as well as the spirit of the Yiddish original. This project was also greatly facilitated and moved forward over a number of years by my wife, Ellen Schalkowsky, who provided constant encouragement, discussion of problem areas, and, when necessary, prodding.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Dedicated to the memory of my mother Chaya Kupershmit Shalkovsky,"), _c('br'), _vm._v("who perished by means unknown to me, in the Stutthof concentration camp"), _c('br'), _vm._v("after nearly four years of Nazi persecution")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Samuel Schalkowsky")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('em', [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "id": "preen1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/preface#rpreen1"
    }
  }, [_vm._v("1")]), _vm._v(". Vilijampole, which appears on the map of the ghetto in this volume, is the Lithuanian spelling.")]), _vm._v(" "), _c('p', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "id": "preen2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/preface#rpreen2"
    }
  }, [_vm._v("2")]), _vm._v(". See Foreword by Esther Mayerowitch-Schwarz to “The History of the Kovno Jewish Ghetto Police (Excerpts),” in "), _c('em', [_vm._v("YIVO Bleter")]), _vm._v(", new series, 3 (1997): 206–207 (Yiddish).")]), _vm._v(" "), _c('p', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "id": "preen3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/preface#rpreen3"
    }
  }, [_vm._v("3")]), _vm._v(". I was born in Kovno, Lithuania, in 1925 and was an inmate of the Kovno ghetto until February 1942, when I was transferred to the ghetto in Riga, Latvia. In August 1943, when the Riga ghetto was liquidated, I was taken to the Kaiserwald concentration camp outside Riga. In September 1944 I was shipped (by boat and barge) to the Stutthof concentration camp. From November 1944 until my liberation in April 1945 I was in a slave labor camp in Magdeburg.")]), _vm._v(" "), _c('p', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "id": "preen4"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/preface#rpreen4"
    }
  }, [_vm._v("4")]), _vm._v(". Another Kovno survivor writes: “I was so deeply and lastingly shocked by the inhumane, almost animalistic conduct of the Lithuanians that a short time after the war I discovered I was no longer fluent in Lithuanian. Suddenly I could no longer utter sentences in this language that I had spoken as well as my mother tongue. Worried that there was something very wrong with my brain, I went to a doctor who determined that I had suffered such a shock from my observations outside the ghetto that a mental block now paralyzed my memory, preventing me from recalling this language.” Memoir by Zev Birger, "), _c('em', [_vm._v("No Time for Patience: My Road from Kaunas to Jerusalem")]), _vm._v(" (New York: Newmarket Press, 1999), 59.")]), _vm._v(" "), _c('p', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "id": "preen5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/preface#rpreen5"
    }
  }, [_vm._v("5")]), _vm._v(". For a critique of some aspects of Dov Levin’s article and his response, see Letter to the Editor by Samuel Schalkowsky in "), _c('em', [_vm._v("Yad Vashem Studies")]), _vm._v(" 31 (2003): 433–437.")]), _vm._v(" "), _c('p', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _c('a', {
    attrs: {
      "id": "preen6"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/preface#rpreen6"
    }
  }, [_vm._v("6")]), _vm._v(". See, for example, Alex Faitelson, "), _c('em', [_vm._v("Heroism and Bravery in Lithuania 1941–1945")]), _vm._v(" (Jerusalem: Gefen Publishing House, 1996).")]), _vm._v(" "), _c('p', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "id": "preen7"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/preface#rpreen7"
    }
  }, [_vm._v("7")]), _vm._v(". Avraham Tory, "), _c('em', [_vm._v("Surviving the Holocaust: The Kovno Ghetto Diary")]), _vm._v(" (Cambridge, Mass.: Harvard University Press), 1990.")]), _vm._v(" "), _c('p', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "id": "preen8"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/preface#rpreen8"
    }
  }, [_vm._v("8")]), _vm._v(". Leib Garfunkel, "), _c('em', [_vm._v("The Destruction of Kovno’s Jewry")]), _vm._v(" (Hebrew) (Jerusalem: Yad Vashem, 1959).")]), _vm._v(" "), _c('p', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "id": "preen9"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/preface#rpreen9"
    }
  }, [_vm._v("9")]), _vm._v(". Ibid., 176–184.")]), _vm._v(" "), _c('p', {
    staticClass: "endnote1"
  }, [_c('a', {
    attrs: {
      "id": "preen10"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/preface#rpreen10"
    }
  }, [_vm._v("10")]), _vm._v(". Josef Gar, "), _c('em', [_vm._v("The Destruction of Jewish Kovno")]), _vm._v(" (Yiddish) (Munich: Association of Lithuanian Jews in the American Zone in Germany), 1948.")]), _vm._v(" "), _c('p', {
    staticClass: "endnote1"
  }, [_c('a', {
    attrs: {
      "id": "preen11"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/preface#rpreen11"
    }
  }, [_vm._v("11")]), _vm._v(". Personal communication from Henry Kopleman, grandson of Michael Kopelman, 2004.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b285ee4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 75
// module chunks = 0